export const SET_IS_VALID_IBAN_SERVICE_RESPONSE =
  'iban//SET_IS_VALID_IBAN_SERVICE_RESPONSE';
export const SET_IS_IBAN_VALIDATING = 'iban//SET_IS_IBAN_VALIDATING';

export function setIsValidIbanServiceResponse(value) {
  return {
    type: SET_IS_VALID_IBAN_SERVICE_RESPONSE,
    value
  };
}

export function setIsIbanValidating(value) {
  return {
    type: SET_IS_IBAN_VALIDATING,
    value
  };
}

const initialState = {
  isIbanValidating: false,
  isValidIbanServiceResponse: false
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_IS_VALID_IBAN_SERVICE_RESPONSE:
      return {
        ...state,
        isValidIbanServiceResponse: action.value
      };
    case SET_IS_IBAN_VALIDATING:
      return {
        ...state,
        isIbanValidating: action.value
      };
    default:
      return state;
  }
}
